<template>
    <page-section class="page-section--first page-section--sm">
        <v-row>
            <v-col cols="12" lg="9">
                <div class="tit-wrap">
                    <h2 class="tit tit--lg">
                        리본바이옴, <br />
                        <span class="primary--text">식물성유산균으로 미래</span>를 만듭니다.
                    </h2>
                </div>
                <v-row>
                    <v-col cols="12">
                        <div class="tit tit--sm font-weight-medium line-height-15">
                            식물성유산균을 기반으로, <br />
                            더 나은 삶을 위한 솔루션을 만듭니다.
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <p class="txt txt--lg line-height-15">
                            ㈜웰빙엘에스는 장류·김치 등 발효 식품에서 특허받은 식물성유산균 기술을 바탕으로 <br class="d-none d-lg-block" />
                            프리·프로·포스트바이오틱스 분야를 선도하는 미생물 전문기업입니다. <br class="d-none d-lg-block" />
                            ㈜리본바이옴은 이러한 웰빙엘에스의 기술력을 기반으로, 온·오프라인 유통, 파트너십 지원, <br class="d-none d-lg-block" />
                            글로벌 세일즈를 전담하며 제조와 판매의 시너지를 통해 더 나은 삶을 위한 건강 솔루션을 제안합니다.
                        </p>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="3" class="d-none d-lg-block">
                <v-img src="/images/about/ceo.png" alt="" class="ceo-image" />
            </v-col>
        </v-row>
    </page-section>
</template>

<script>
import PageSection from "@/components/client/templates/page-section.vue";

export default {
    components: {
        PageSection,
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 1024px) {
    .ceo-image {
        transform: translateY(var(--page-section-padding-y-sm));
    }
}
</style>